import styled from "styled-components";

export const ThumbnailWrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	z-index: 10;
	cursor: pointer;
	display: block;

	&:hover img {
		opacity: 0.9;
	}

	pointer-events: auto !important;
	user-select: none;
`;
export const ThumbnailImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	transition: opacity 0.2s ease;
	pointer-events: none;
	user-select: none;
`;

export const FullscreenOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.9);
	z-index: 99999999 !important;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: fadeIn 0.3s ease-out;
	backdrop-filter: blur(2px);

	@keyframes fadeIn {
		from {
			opacity: 0;
			backdrop-filter: blur(0px);
		}
		to {
			opacity: 1;
			backdrop-filter: blur(2px);
		}
	}

	@media (max-width: 768px) {
		background: rgba(0, 0, 0, 0.95);
	}
`;

export const ZoomableImageContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	user-select: none;
	touch-action: none;
`;

export const ZoomedImage = styled.img`
	max-width: 90vw;
	max-height: 90vh;
	object-fit: contain;
	transform-origin: center;
	pointer-events: none;
	user-select: none;

	@media (max-width: 768px) {
		max-width: 95vw;
		max-height: 85vh;
	}
`;

export const ZoomIndicator = styled.div`
	position: absolute;
	bottom: 30px;
	left: 50%;
	transform: translateX(-50%);
	background: rgba(0, 0, 0, 0.7);
	color: white;
	padding: 8px 16px;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 500;
	backdrop-filter: blur(10px);
	border: 1px solid rgba(255, 255, 255, 0.1);
	z-index: 10000;
	pointer-events: auto;
	user-select: none;
	transition: opacity 0.2s ease;
	display: flex;
	align-items: center;
	gap: 12px;

	@media (max-width: 768px) {
		bottom: 20px;
		font-size: 12px;
		padding: 6px 12px;
		gap: 8px;
	}
`;

export const ZoomButton = styled.button`
	background: rgba(255, 255, 255, 0.2);
	border: 1px solid rgba(255, 255, 255, 0.3);
	color: white;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	font-size: 16px;
	font-weight: bold;
	line-height: 1;
	transition: all 0.2s ease;
	user-select: none;

	&:hover {
		background: rgba(255, 255, 255, 0.3);
		border-color: rgba(255, 255, 255, 0.5);
		transform: scale(1.1);
	}

	&:active {
		transform: scale(0.95);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;

		&:hover {
			background: rgba(255, 255, 255, 0.2);
			border-color: rgba(255, 255, 255, 0.3);
			transform: none;
		}
	}

	@media (max-width: 768px) {
		width: 24px;
		height: 24px;
		font-size: 14px;
	}
`;

export const ZoomPercentage = styled.span`
	font-size: 14px;
	font-weight: 500;
	min-width: 40px;
	text-align: center;

	@media (max-width: 768px) {
		font-size: 12px;
		min-width: 35px;
	}
`;
